import { render, staticRenderFns } from "./KisTasks.vue?vue&type=template&id=4b633e53"
import script from "./KisTasks.js?vue&type=script&lang=js&external"
export * from "./KisTasks.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports